import { Helpers } from '../../helpers';
import { IRigType } from '../../interfaces/irig-type';
import { Rig } from '../rig';

export class RigTypeBase {
  RigTypeId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;
  SysStartTime: Date;
  SysEndTime: Date;

  Rigs_RigType?: Array<Rig> | null;

  constructor(item?: IRigType) {
    if (item) {

      this.RigTypeId = item.RigTypeId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;

      this.Rigs_RigType = Helpers.createClassArray(Rig, item.Rigs_RigType);
    }
  }
}